import { render, staticRenderFns } from "./ShortSummary.vue?vue&type=template&id=5065274a&scoped=true&"
import script from "./ShortSummary.vue?vue&type=script&lang=js&"
export * from "./ShortSummary.vue?vue&type=script&lang=js&"
import style0 from "./ShortSummary.vue?vue&type=style&index=0&id=5065274a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5065274a",
  null
  
)

export default component.exports